// import { SignupRequest, User, UserSearchFilter, UserSearchResponse } from '@api/entities';
import { SignupRequest, User, UserSearchFilter, UserSearchResponse } from 'src/api/entities';
import { IUserApiClients, UserApiClients } from './user.api.client';

export interface IUserApiService {
    search(page: number, size: number, query?: string, sort?: { [key: string]: string | undefined }, filter?: UserSearchFilter): Promise<UserSearchResponse>;
    create(request: SignupRequest): Promise<User>;
    delete(email: string): Promise<{[key: string]: boolean}>;
    getUserById(id: number): Promise<User>;
}

export class UserApiService implements IUserApiService {
    private static instance: UserApiService;
    private api: IUserApiClients;

    private constructor(basePath: string) {
        this.api = UserApiClients.getInstance(basePath);
    }

    static getInstance(basePath: string) {
        if (UserApiService.instance == null) {
            UserApiService.instance = new UserApiService(basePath);
        }
        return UserApiService.instance;
    }

    async create(request: SignupRequest): Promise<User> {
        const response: User = (await this.api.user.create(request)).data;
        return response;
    }

    async search(page: number, size: number, query?: string, sort?: { [key: string]: string }, filter?: UserSearchFilter): Promise<UserSearchResponse> {
        return (
            await this.api.user.searchUsers({
                page,
                size,
                query,
                sort,
                filter,
            })
        ).data;
    }

    async getUserById(id: number): Promise<User> {
        const user = await this.api.user.getbyId(id);
        return user.data;
    }
    async delete(email: string): Promise<{[key: string]: boolean}> {
        const user = await this.api.user.delete1(email);
        return user.data;
    }
}
